import { createStore, createLogger } from 'vuex';

import {
  store as bookView,
  BookViewStore,
  State as BookViewState,
} from '@/store/modules/bookView';

import { store as kpi, KpiStore, State as KpiState } from '@/store/modules/kpi';

import {
  store as clientView,
  ClientViewStore,
  State as ClientViewState,
} from '@/store/modules/clientView';

import {
  store as prospectView,
  ProspectViewStore,
  State as ProspectViewState,
} from '@/store/modules/prospectView';

import {
  store as serviceView,
  ServiceViewStore,
  State as ServiceViewState,
} from '@/store/modules/serviceView';

import {
  store as general,
  GeneralStore,
  State as GeneralState,
} from '@/store/modules/general';

import {
  store as taskView,
  TaskViewStore,
  State as TaskViewState,
} from '@/store/modules/taskView';

import {
  store as opportunities,
  OpportunitiesStore,
  State as OpportunitiesState,
} from '@/store/modules/opportunities';

import {
  store as history,
  HistoryStore,
  State as HistoryState,
} from '@/store/modules/history';

import {
  store as reporting,
  ReportingStore,
  State as ReportingState,
} from '@/store/modules/reporting';

import {
  store as salesChurn,
  SalesChurnStore,
  State as SalesChurnState,
} from '@/store/modules/salesChurn';

import {
  store as targets,
  TargetsStore,
  State as TargetsState,
} from '@/store/modules/targets';

import {
  store as leads,
  LeadsStore,
  State as LeadsState,
} from '@/store/modules/leads';

export type RootState = {
  bookView: BookViewState;
  clientView: ClientViewState;
  prospectView: ProspectViewState;
  kpi: KpiState;
  serviceView: ServiceViewState;
  general: GeneralState;
  taskView: TaskViewState;
  opportunities: OpportunitiesState;
  history: HistoryState;
  reporting: ReportingState;
  salesChurn: SalesChurnState;
  targets: TargetsState;
  leads: LeadsState;
};

export type Store = BookViewStore<Pick<RootState, 'bookView'>> &
  ClientViewStore<Pick<RootState, 'clientView'>> &
  ProspectViewStore<Pick<RootState, 'prospectView'>> &
  KpiStore<Pick<RootState, 'kpi'>> &
  ServiceViewStore<Pick<RootState, 'serviceView'>> &
  GeneralStore<Pick<RootState, 'general'>> &
  TaskViewStore<Pick<RootState, 'taskView'>> &
  HistoryStore<Pick<RootState, 'history'>> &
  ReportingStore<Pick<RootState, 'reporting'>> &
  SalesChurnStore<Pick<RootState, 'salesChurn'>> &
  OpportunitiesStore<Pick<RootState, 'opportunities'>> &
  TargetsStore<Pick<RootState, 'targets'>> &
  LeadsStore<Pick<RootState, 'leads'>>;

// Plug in logger when in development environment
const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger({})] : [];

export const store = createStore({
  plugins,
  modules: {
    bookView,
    kpi,
    clientView,
    serviceView,
    prospectView,
    general,
    taskView,
    opportunities,
    history,
    reporting,
    salesChurn,
    targets,
    leads,
  },
});

export function useStore(): Store {
  return store as Store;
}
